import { RoomAvailability } from '@/types/types'

interface Parameters {
  available_rooms?: RoomAvailability
  roomId: number
  pax: number
}

const isRoomAvailableForPax = ({ available_rooms, roomId, pax }: Parameters) => {
  return available_rooms !== undefined && pax in available_rooms && available_rooms[pax].includes(roomId)
}

export default isRoomAvailableForPax
